import * as React from "react";

const BubblePen: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" focusable="false" viewBox="0 -960 960 960">
            <path fill="none" d="M-2-2h24v24H-2z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M260-400h62q8 0 15.5-3.5T350-412l224-222q6-6 6-15t-6-15l-70-70q-6-6-15-6t-15 6L252-510q-5 5-8.5 12.5T240-482v62q0 8 6 14t14 6Zm160 0h260q17 0 28.5-11.5T720-440q0-17-11.5-28.5T680-480H500l-80 80ZM240-240l-92 92q-19 19-43.5 8.5T80-177v-623q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240Zm-34-80h594v-480H160v525l46-45Zm-46 0v-480 480Z"
            />
        </svg>
    );
};

export default React.memo(BubblePen);
